import React from 'react';
import { Button } from '../components/ui/Button';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './NotFound.css';

export const NotFound: React.FC = () => {
  useDocumentTitle('Page Not Found');
  return (
    <div className="notfound-page page-enter">
      <section className="notfound-hero">
        <div className="notfound-hero__content">
          <p className="notfound-hero__code">404</p>
          <h1 className="notfound-hero__title">We couldn't find that page</h1>
          <p className="notfound-hero__message">
            It may have moved, or the address may be incomplete.
          </p>
          <div className="notfound-hero__actions">
            <Button asLink="/" variant="primary" size="lg">
              Go to Home
            </Button>
            <Button asLink="/services" variant="secondary" size="md">
              Explore Services
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

NotFound.displayName = 'NotFound';
